<template>
  <div>
    <CRow>
      <CCol sm="12">
        <ProductsTable
          :items="products"
          hover
          striped
          border
          small
          fixed
          caption="Productos"
          @refresh="refreshItems"
          :permissions="permissions"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import ProductsTable from '../../components/products/ProductsTable.vue'
import ws from '../../services/products';
import account_ws from '../../services/account';
import store from '../../store'

export default {
  name: 'Products',
  components: { ProductsTable },
  data: function () {
		return {
      products: [],
      permissions: {}
    }
  },
  mounted: async function() {
    await this.loadInitialData();
  },
  methods: {
    async loadInitialData () {
      this.loading();

      try {
        const [productsResponse, infoResponse] = await Promise.all([
          ws.get(),
          account_ws.getInfo()
        ]);

        if(productsResponse.type == "success"){
          this.products = productsResponse.data;
        } else {
          this.showToast(productsResponse.type || 'error', productsResponse.message || 'No fue posible cargar productos');
        }

        if(infoResponse.type == "success"){
          this.permissions = infoResponse.data.user.permissions;
        } else {
          this.showToast(infoResponse.type || 'error', infoResponse.message || 'No fue posible cargar permisos');
        }
      } catch (error) {
        this.showToast('error', 'Ocurrió un error al cargar la información inicial');
      }

      this.loaded();
    },
    refreshItems (items){
      this.loading();
      this.products = items;
      this.loaded();
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
